// dependencies
import React from "react";
import { Link } from "yarrr";
import { Map } from "immutable";
import PropTypes from "prop-types";
import { Ghost, Flame } from "lucide-react";

// components
import Avatar from "Components/Avatar";
import BrowserLogo from "Components/BrowserLogo";

// style
import css from "./Request";

export default class Request extends React.Component {
	static propTypes = {
		request: PropTypes.instanceOf(Map).isRequired,
	};

	state = {
		isOpen: false,
		hasError: false,
	};

	componentDidCatch = () => {
		this.setState({ hasError: true });
	};

	handleOpenRequest = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	render = () => {
		const { request } = this.props;
		const { isOpen, hasError } = this.state;

		if (hasError) {
			return null;
		}

		const isPossessed = !!request.getIn(["possessor"], null);

		return (
			<div className={`${css.requestWrapper} ${isPossessed ? css.isPossessed : ""}`}>
				<div className={css.smallContainer}>
					<div className={css.topData}>
						<div className={`${css.method} ${request.get("method").toLowerCase()}`}>
							{request.get("method")}
						</div>

						{isPossessed ? (
							<div className={css.possessed}>
								<Ghost size={16} />
							</div>
						) : null}

						<div className={css.url}>{request.get("url")}</div>

						<Link
							href={`/flame/${request.getIn(["request"])}/`}
							onClick={this.handleFlameView}
							className={css.flameButton}
						>
							<Flame size={16} />
						</Link>

						<div onClick={this.handleOpenRequest} className={css.viewButton}>
							{isOpen ? "Close" : "View"}
						</div>
					</div>

					<div className={css.lowerData}>
						<div>
							<Avatar
								className={`${css.lowerItem} ${css.avatar}`}
								size={25}
								userID={request.getIn(["user", "id"], ":)")}
							/>
							<BrowserLogo
								className={`${css.lowerItem} ${css.browserLogo}`}
								size={25}
								name={request.getIn(["userAgentParsed", "browser", "name"], "default")}
							/>
						</div>

						<div testid="userInfo" className={css.userInfo}>
							<Link href={`/breadcrumbs/${request.getIn(["user", "id"])}/`}>
								{request.getIn(["user", "name"])}
							</Link>{" "}
							-
							<Link
								className={css.companyInfo}
								href={`/companies/${request.getIn(["user", "company"])}/`}
							>
								{request.getIn(["user", "companyName"])}
							</Link>
						</div>

						<div className={`${css.lowerItem} ${css.time}`}>
							{request.get("startTime").format("MMM D YYYY h:mm a")}{" "}
							<span>({request.get("deltaTime").toFixed(3)} ms)</span>
						</div>
					</div>
				</div>

				{isOpen ? (
					<div className={css.verboseContainer}>
						<div>
							<div className={css.prettyJSON}>{JSON.stringify(request.toJS(), null, 2)}</div>
						</div>
					</div>
				) : null}
			</div>
		);
	};
}
